import {deleteRequest, getRequest, postRequest} from './apiRequests';
import localStorageRepository from '@/domain/repository/LocalStorageRepository';
import {DocumentProperties, ParcelDocumentCreationDto, ParcelDocumentDto} from '@/domain/entities/ParcelDocument';
import {buildUrl, HttpError} from '@/domain/repository/jsonHttp';
import {API_URL} from '@/config';

const parcelDocumentsRepository = {
  getParcelDocuments: (parcelUuid: string): Promise<Array<DocumentProperties>> => {
    const {access} = localStorageRepository.getCredentials();
    return getRequest<Array<DocumentProperties>>({
      path: `parcel-documents?parcelUuid=${parcelUuid}`,
      headers: {
        'Authorization': `Bearer ${access}`
      }
    });
  },
  createParcelDocument: (parcelDocument: ParcelDocumentCreationDto): Promise<ParcelDocumentDto> => {
    const {access} = localStorageRepository.getCredentials();
    return postRequest<ParcelDocumentDto>({
      path: 'parcel-documents/',
      headers: {
        'Authorization': `Bearer ${access}`
      },
      body: parcelDocument
    });
  },
  createDocumentData: async (documentUuid: string, formData: FormData): Promise<void> => {
    const {access} = localStorageRepository.getCredentials();
    const url = buildUrl(API_URL, `parcel-documents/${documentUuid}/data/`);
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${access}`
      },
      body: formData
    });
    if (response.status >= 300 || !response.ok) {
      throw new HttpError(response.status, await response.text());
    }
  },
  deleteParcelDocument: (documentUuid: string): Promise<void> => {
    const {access} = localStorageRepository.getCredentials();
    return deleteRequest({
      path: `parcel-documents/${documentUuid}/`,
      headers: {
        'Authorization': `Bearer ${access}`
      }
    });
  },
  getDocumentData: async (dataUrl: string): Promise<Blob> => {
    const { access } = localStorageRepository.getCredentials();
    const response = await fetch(dataUrl,
      {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      }
    );

    if (response.status >= 300 || !response.ok) {
      throw new Error(`Error downloading file: ${response.statusText}`);
    }
    return await response.blob();
  }
};

export default parcelDocumentsRepository;
